var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckShieldOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6974 2.15241C11.8931 2.0825 12.1071 2.0825 12.3028 2.15241L19.3028 4.65241C19.661 4.78033 19.9001 5.11962 19.9001 5.49998V13C19.9001 15.8507 18.3319 18.0768 16.6572 19.5506C15.8145 20.2922 14.9201 20.8668 14.1257 21.2598C13.3682 21.6345 12.5894 21.9 12.0001 21.9C11.4108 21.9 10.632 21.6345 9.87452 21.2598C9.08005 20.8668 8.18569 20.2922 7.34303 19.5506C5.66825 18.0768 4.1001 15.8507 4.1001 13V5.49998C4.1001 5.11962 4.3392 4.78033 4.69739 4.65241L11.6974 2.15241ZM5.9001 6.13422V13C5.9001 15.1493 7.08194 16.9231 8.53216 18.1993C9.25201 18.8328 10.0139 19.3206 10.6726 19.6464C11.3682 19.9905 11.8394 20.1 12.0001 20.1C12.1608 20.1 12.632 19.9905 13.3276 19.6464C13.9863 19.3206 14.7482 18.8328 15.468 18.1993C16.9183 16.9231 18.1001 15.1493 18.1001 13V6.13422L12.0001 3.95565L5.9001 6.13422Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1365 9.36358C16.488 9.71505 16.488 10.2849 16.1365 10.6364L11.6365 15.1364C11.285 15.4878 10.7152 15.4878 10.3637 15.1364L7.8637 12.6364C7.51223 12.2849 7.51223 11.7151 7.8637 11.3636C8.21517 11.0121 8.78502 11.0121 9.13649 11.3636L11.0001 13.2272L14.8637 9.36358C15.2152 9.01211 15.785 9.01211 16.1365 9.36358Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckShieldOutline);
export default __webpack_public_path__ + "static/media/check_shield_outline.7691deb9ab2ab7e1c90088b5fa973469.svg";
export { ForwardRef as ReactComponent };